<script setup lang="ts">
import { CSSProperties } from 'vue';
import { Statistic } from 'ant-design-vue';

interface Props {
  title?: string;
  value: string | number;
  precision?: number;
  valueStyle?: CSSProperties;
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  precision: 3,
  valueStyle: () => ({ fontSize: '1rem', color: '#F59600' }),
});
</script>

<template>
  <Statistic
    :title="props.title"
    :value="props.value"
    :precision="props.precision"
    :valueStyle="props.valueStyle"
  />
</template>

<style scoped></style>
